module.exports = __webpack_public_path__ + "static/media/michael@3x.18b0365b.png";